<template>
  <div class="relative inline-block" @click.stop>
    <!-- Trigger (the chip) -->
    <button
      ref="trigger"
      class="text-[11px] font-medium px-2 py-0.5 rounded cursor-pointer"
      :class="chipClass"
      :style="chipStyle"
      @click="toggle"
    >
      {{ displayLabel }}
    </button>

    <!-- Dropdown (fixed to viewport to escape overflow clipping) -->
    <teleport to="body">
      <div
        v-if="open"
        class="fixed z-[9999] bg-white border border-gray-200 rounded shadow-lg py-1 min-w-[120px]"
        :style="dropdownStyle"
      >
        <button
          v-for="opt in options"
          :key="opt.value"
          class="w-full text-left px-3 py-1.5 text-xs hover:bg-gray-50 flex items-center"
          @click="select(opt.value)"
        >
          <span
            v-if="opt.value === modelValue"
            class="w-1.5 h-1.5 rounded-full bg-gray-800 mr-2 shrink-0"
          />
          <span v-else class="w-1.5 mr-2 shrink-0" />
          <span
            class="px-1.5 py-0.5 rounded text-[11px] font-medium"
            :class="opt.chipClass"
            :style="opt.chipStyle"
          >
            {{ opt.label }}
          </span>
        </button>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'Support_InlineDropdown',
  props: {
    modelValue: { type: [String, Number], default: null },
    options: { type: Array, required: true },
    chipClass: { type: String, default: '' },
    chipStyle: { type: Object, default: null },
    displayLabel: { type: String, default: '' },
    alignRight: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      open: false,
      dropdownStyle: {},
    };
  },
  mounted() {
    document.addEventListener('click', this.closeOnOutsideClick);
    window.addEventListener('scroll', this.reposition, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeOnOutsideClick);
    window.removeEventListener('scroll', this.reposition, true);
  },
  methods: {
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.$nextTick(() => this.reposition());
      }
    },
    reposition() {
      if (!this.open || !this.$refs.trigger) return;
      const rect = this.$refs.trigger.getBoundingClientRect();
      const dropdownHeight = 200; // estimated max
      const spaceBelow = window.innerHeight - rect.bottom;
      const openUpward = spaceBelow < dropdownHeight && rect.top > spaceBelow;

      this.dropdownStyle = {
        top: openUpward ? 'auto' : (rect.bottom + 4) + 'px',
        bottom: openUpward ? (window.innerHeight - rect.top + 4) + 'px' : 'auto',
        left: this.alignRight ? 'auto' : rect.left + 'px',
        right: this.alignRight ? (window.innerWidth - rect.right) + 'px' : 'auto',
      };
    },
    select(value) {
      this.$emit('update:modelValue', value);
      this.open = false;
    },
    closeOnOutsideClick() {
      this.open = false;
    },
  },
};
</script>
